<ng-container *ngFor="let button of ttButtons">
    <tt-form-field-button
        [ttId]="button.id"
        [ttIcon]="button.icon"
        [ttTooltip]="button.tooltip"
        [ttTranslateTooltip]="button.translateTooltip"
        [ttType]="button.type"
        (ttClick)="button?.onClick($event)"
        [ttGoto]="button.goto"
        [ttBeforeGoto]="button.beforeGoto"
        [ttGotoParms]="button.gotoParms"
        [ttButtonParms]="ttButtonParms"
    ></tt-form-field-button>
</ng-container>
